import React from 'react'
import { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Helmet } from '@dr.pogodin/react-helmet'
import useAuth from '../../hooks/useAuth'

import { Grid, LinearProgress, Divider as MuiDivider, Typography } from '@mui/material'
import { DataGridPro, gridClasses } from '@mui/x-data-grid-pro'
import { enUS, svSE } from '@mui/x-data-grid-pro/locales'
import { spacing } from '@mui/system'
import { useTranslation } from 'react-i18next'
import AdvisorApi from '../../api/AdvisorApi'
import { Link } from 'react-router-dom'
import { CustomDataGridToolbar } from '../../components/CustomDataGridToolbar'

const Divider = styled(MuiDivider)(spacing)

const gridTextI18n = (locale) => {
    if (locale?.startsWith('sv')) {
        return svSE.components.MuiDataGrid.defaultProps.localeText
    } else {
        return enUS.components.MuiDataGrid.defaultProps.localeText
    }
}

function AdvisorsGrid({ advisors }) {
    const { i18n } = useTranslation()
    const locale = i18n.language
    const cols = [
        {
            field: 'name',
            headerName: 'Namn',
            flex: 1,
            renderCell: (params) => <Link to={`/advisors/${params.row.id}`}>{params.row.name}</Link>,
        },
        { field: 'numIssuesAsFinancialAdvisor', headerName: 'Finansiell rådgivare, antal ggr', flex: 1 },
        { field: 'numIssuesAsLegalAdvisor', headerName: 'Juridisk rådgivare', flex: 1 },
        { field: 'numIssuesAsIssuingAgent', headerName: 'Utgivare', flex: 1 },
    ]
    const disableSelectedSellOutlineStyle = {
        [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
            outline: 'none',
        },
        [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
            outline: 'none',
        },
    }
    return (
        // adapt filter: https://mui.com/x/react-data-grid/filtering/customization/#create-a-custom-operator
        <DataGridPro
            sx={disableSelectedSellOutlineStyle}
            localeText={gridTextI18n(locale)}
            disableColumnMenu
            disableRowSelectionOnClick
            rows={advisors}
            columns={cols}
            density='compact'
            initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
            }}
            pagination={true}
            pageSizeOptions={[10, 25, 100]}
            getRowId={(row) => row.id}
            getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
            slots={{ toolbar: CustomDataGridToolbar }}
            showToolbar
        />
    )
}

function AdvisorsView() {
    const [advisors, setAdvisors] = useState([])
    const [loading, setLoading] = useState(true)
    const { isAuthenticated } = useAuth()
    const advisorApi = new AdvisorApi()

    useEffect(() => {
        if (!isAuthenticated) return
        const fetchData = async () => {
            const advisorEntities = await advisorApi.findAll()
            // sort by name
            const mappedAdvisors = advisorEntities.sort((a, b) => a.name.localeCompare(b.name))
            setAdvisors(mappedAdvisors)
            setLoading(false)
        }
        fetchData()
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Helmet title='Rådgivare' />
            <Typography variant='h3' gutterBottom display='inline'>
                Rådgivare
            </Typography>

            {/* <Breadcrumbs mt={2}>
                <Link component={NavLink} to='/'>
                    {t('site.nav.dashboard')}
                </Link>
                <Typography>{t('site.nav.companies')}</Typography>
            </Breadcrumbs> */}

            <Divider my={6} />

            <Grid container spacing={6}>
                <Grid size={12}>
                    {loading && <LinearProgress />}
                    {!loading && <AdvisorsGrid advisors={advisors} />}
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default AdvisorsView
